import { course, student } from "../client";
const config = {
  headers: {},
  signal: null,
};

export const searchStudent = (params) => {
  config.signal = params.signal;

  const user = {
    flag: "studentSearch",
    parameters: {
      studentSearch: params.studentSearch,
    },
  };
  return student.post("/student/search", user, config);
};

export const studentPersonal = (params) => {
  const user = {
    flag: "addStudentProfile",
    parameters: {
      studentPersonalInfo: params.studentPersonalInfo,
    },
  };
  return student.post("/student/info", user);
};

export const updateStudentProfile = (params) => {
  const user = {
    flag: "updateStudentProfile",
    parameters: {
      studentPersonalInfo: params.studentPersonalInfo,
    },
  };
  return student.post("/student/info", user);
};

export const studentEducation = (params) => {
  // //console.log(params, "api")
  const user = {
    flag: "addStudentEducation",
    parameters: {
      educationList: params.educationList,
    },
  };
  return student.post("/student/education", user);
};

export const addStudentContacts = (params) => {
  const user = {
    flag: "addStudentContacts",
    parameters: {
      contactsList: params.studentContacts,
    },
  };
  return student.post("/student/contacts", user);
};

export const addAchievements = (params) => {
  const user = {
    flag: "addAchievements",
    parameters: {
      achievementsList: params.achievementsList,
    },
  };
  return student.post("/student/achievements", user);
};

export const addExtraCurricularActivities = (params) => {
  const user = {
    flag: "addExtraCurricularActivities",
    parameters: {
      extraCurricularActivityList: params.extraCurricularActivityList,
    },
  };
  return student.post("/student/extraCurricular", user);
};

export const addInterests = (params) => {
  const user = {
    flag: "addInterests",
    parameters: {
      interestList: params.interestList,
    },
  };
  return student.post("/student/interest", user);
};

export const getStudentInfo = (params) => {
  const user = {
    flag: "getStudentInfo",
    parameters: {
      getStudentInfo: params,
    },
  };
  return student.post("/get/student", user);
};

export const deleteStudentInfo = (params) => {
  // //console.log("deleteStudentInfo", params);
  const user = {
    flag: "deleteStudentInfo",
    parameters: {
      deleteStudentInfo: params.deleteStudentInfo,
    },
  };
  return student.delete("/delete/student", { data: user });
};

export const deleteStudentEducation = (params) => {
  const user = {
    flag: "deleteStudentEducation",
    parameters: {
      deleteInfo: params,
    },
  };
  return student.delete("/delete/student/edu", { data: user });
};

export const deleteStudentContacts = (params) => {
  const user = {
    flag: "deleteStudentContacts",
    parameters: {
      deleteInfo: params,
    },
  };
  return student.delete("/delete/student/contacts", { data: user });
};

export const deleteStudentAchievements = (params) => {
  const user = {
    flag: "deleteStudentAchievements",
    parameters: {
      deleteInfo: params,
    },
  };
  return student.delete("/delete/student/achievements", { data: user });
};

export const deleteStudentExtraCurricular = (params) => {
  const user = {
    flag: "deleteStudentExtraCurricular",
    parameters: {
      deleteInfo: params,
    },
  };
  return student.delete("/delete/student/extracurricular", { data: user });
};

export const uploadProfilePic = (params) => {
  // //console.log("uploadProfilePic ===>", params);
  const user = {
    flag: "uploadProfilePic",
    parameters: {
      uploadProfilePic: params.uploadProfilePic,
    },
  };
  return student.post("/student/uploadpic", user);
};

export const getProgram = (params) => {
  const user = {
    flag: "getProgram",
    parameters: {course:params.course},
  };
  return course.post("/get/programs", user);
};
